import func0x from './0x';
import func1x from './1x';
import func2x from './2x';
import func3x from './3x';
import func4x from './4x';
import func5x from './5x';
import func6x from './6x';
import func7x from './7x';
import func8x from './8x';
import func9x from './9x';
import func10x from './10x';
import func11x from './11x';
import func12x from './12x';

/*
aura: (id=skillID, stats=casterStats, level, active=activeData, itemAura=false) => {
  level: aura level to determine precedence
  filter: bitmask for aura target
  targets: array of spell targets
  state: state to apply to player
  stats: stats callback to apply to player (if state check succeeds)
  itemtypes: item types for masteries
  targetState: state to apply to target
  targetStats: stats callback to apply to target (if state check succeeds)
  priority: order in which to apply auras: higher = earlier (default 0)
  targetCheck: callback function to check target validity (id, stats) => boolean
}
*/

const skillFunctions = {
  ...func0x,
  ...func1x,
  ...func2x,
  ...func3x,
  ...func4x,
  ...func5x,
  ...func6x,
  ...func7x,
  ...func8x,
  ...func9x,
  ...func10x,
  ...func11x,
  ...func12x,
};

export default skillFunctions;
